import { html, LitElement } from 'lit';

class ClockMark extends LitElement {
  static properties = {
    svgFillColor: { type: String },
    svgHeight: { type: String },
    svgWidth: { type: String },
  };

  render() {
    return html`
      <svg fill=${this.svgFillColor || '#808080'} width=${this.svgWidth || '14px'} height=${this.svgHeight || '14px'} viewBox="0 0 24 24" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <title></title>
          <path
            d="M12,13.41,13.41,12,8.46,7.05,7.05,8.46Zm7.07-8.48A9.93,9.93,0,0,0,12,2H11V6h2V4.06A8,8,0,1,1,6.34,6.34l.71-.7L5.64,4.22l-.71.71A10,10,0,1,0,19.07,19.07a10,10,0,0,0,0-14.14Z"
          ></path>
        </g>
      </svg>
    `;
  }
}

customElements.define('clock-mark', ClockMark);
